<template>
  <span>

    <span @click="showAddSection"><slot></slot></span>

    <b-modal v-model="modalAdd" size="lg" centered no-fade>
      <div slot="modal-header">{{$t('SERVICES.ADD.TITLE')}}</div>
      <div class="p-4 text-center" v-if="modalLoading">
        <img src="/img/loading.gif" />
        <h5 style="margin: 0; padding: 0;">{{$t('SERVICES.ADD.PROCESSING')}}</h5>
      </div>
      <div class="pl-4 pr-4" v-if="modalLoading === false">
        <form enctype="multipart/form-data" v-on:submit.prevent="onSubmit">
          <div class="form-group row">
            <label class="col-form-label">{{ $t('SERVICES.ADD.INPUT_NAME') }}</label>
            <b-input v-on:keyup.enter="addService"
               v-model="serviceName" type="text" name="name" required autofocus ></b-input>
          </div>
        </form>
      </div>
      <div slot="modal-footer" class="w-100">
        <div v-if="modalLoading === false">
          <b-btn @click="hideAddSection">{{ $t('CLOSE')}}</b-btn>

          <b-button
            variant="primary"
            class="btn-fill"
            @click="addService"
          >{{ $t('SERVICES.ADD.SAVE')}}</b-button>
        </div>
      </div>
    </b-modal>
  </span>
</template>
<script>
export default {
  data() {
    return {
      modalAdd: false,
      modalLoading: false,
      serviceName: "",
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    showAddSection() {
      this.modalAdd = true;
    },
    hideAddSection() {
      this.modalAdd = false;
      this.serviceName = "";
      this.modalLoading = false;
    },
    onSubmit(event){
      event.preventDefault();
    },
    addService: function () {
        let self = this;
        this.$http
            .post(process.env.VUE_APP_BACKEND + '/services/add', {
                name: this.serviceName
            })
            .then(function() {
                self.$noty.info(self.$t("SERVICES.ADD.SUCCESS.CREATED_NEW_SERVICE"));
                self.hideAddSection();
                self.$emit("addedService");
            })
            .catch(error => {
                self.$noty.error(self.$t(error.data.message));
            })
    },
  },
  computed: {
    documentName() {
      return (
        this.details.document.name + ":" + this.details.documentVersion.version
      );
    }
  }
};
</script>
<style>
</style>